






















// 参考文档：https://www.npmjs.com/package/vue-property-decorator
// 参考文档：https://www.npmjs.com/package/vue-property-decorator （https://class-component.vuejs.org/guide/class-component.html#methods）
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class HelloWorld extends Vue {
    @Prop({
        type: [Number, String],
        default: '',
    })
    private msg!: string;
    private count = 0;
    private inputValueReal = '';

    get inputValue() {
        return this.inputValueReal;
    }

    set inputValue(value) {
        if (value && value.length < 5) {
            this.inputValueReal = value;
        } else {
            this.$message.warning('输入字符过长');
        }
    }

    private onClickAdd() {
        this.count++;
    }
}
